/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Day_Sheet_HelpInputs */

const en_orders_day_sheet_help = /** @type {(inputs: Orders_Day_Sheet_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sheet mode groups by scheduled day, sorts each group by carrier name, and keeps status updates inline.`)
};

const es_orders_day_sheet_help = /** @type {(inputs: Orders_Day_Sheet_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La vista agrupa por dia programado, ordena cada grupo por transportista y mantiene cambios de estado en linea.`)
};

/**
* | output |
* | --- |
* | "Sheet mode groups by scheduled day, sorts each group by carrier name, and keeps status updates inline." |
*
* @param {Orders_Day_Sheet_HelpInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_day_sheet_help = /** @type {((inputs?: Orders_Day_Sheet_HelpInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Day_Sheet_HelpInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_day_sheet_help(inputs)
	return es_orders_day_sheet_help(inputs)
});